/**
 * NoteBadges Components
 *
 * Badge components for tags, status, and timestamps on notes.
 */

import React from "react";

interface TagBadgeProps {
  tag: string;
  variant?: "default" | "amber" | "violet" | "blue";
}

const variantStyles: Record<string, string> = {
  default: "bg-gray-100 text-gray-700",
  amber: "bg-amber-100 text-amber-700",
  violet: "bg-violet-100 text-violet-700",
  blue: "bg-blue-100 text-blue-700",
};

export const TagBadge: React.FC<TagBadgeProps> = ({
  tag,
  variant = "default",
}) => {
  return (
    <span
      className={`px-2 py-0.5 text-xs rounded-sm ${variantStyles[variant]}`}
    >
      {tag}
    </span>
  );
};

interface StatusBadgeProps {
  status: "pending" | "approved" | "photographer";
}

const statusStyles: Record<string, { bg: string; text: string; label: string }> = {
  pending: { bg: "bg-amber-100", text: "text-amber-700", label: "In attesa" },
  approved: { bg: "bg-emerald-100", text: "text-emerald-700", label: "Approvato" },
  photographer: { bg: "bg-blue-100", text: "text-blue-600", label: "Fotografo" },
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const style = statusStyles[status] || statusStyles.pending;
  return (
    <span className={`px-2 py-0.5 text-xs rounded-sm ${style.bg} ${style.text}`}>
      {style.label}
    </span>
  );
};

interface TimestampBadgeProps {
  date: string;
  className?: string;
}

export const TimestampBadge: React.FC<TimestampBadgeProps> = ({
  date,
  className = "",
}) => {
  const formatted = new Date(date).toLocaleString();
  return (
    <span className={`text-xs text-gray-400 ${className}`}>{formatted}</span>
  );
};
